import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useSearchParams } from 'react-router-dom';
import AuthForm from '../components/auth/AuthForm';

const TELEGRAM_SIGNUP_BIND_KEY = 'psh-signup-telegram-required';

const isTelegramBindPending = () => {
  try {
    return sessionStorage.getItem(TELEGRAM_SIGNUP_BIND_KEY) === '1';
  } catch {
    return false;
  }
};

const Auth = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const [requiresTelegramBind, setRequiresTelegramBind] = React.useState(() => isTelegramBindPending());

  const redirectTo = React.useMemo(() => {
    const raw = searchParams.get('redirect') || '/';
    if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/auth')) return '/';
    return raw;
  }, [searchParams]);

  React.useEffect(() => {
    if (!isAuthenticated) {
      setRequiresTelegramBind(false);
      return;
    }
    setRequiresTelegramBind(isTelegramBindPending());
  }, [isAuthenticated]);

  if (isAuthenticated && !requiresTelegramBind) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <AuthForm
      onTelegramBindCompleted={() => {
        setRequiresTelegramBind(false);
      }}
    />
  );
};

export default Auth;
